import {Component, Injector} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

import {QuestionPage} from '../../components/question-page/question-page';
import { NavService } from 'shared/nav/nav.service';

@Component({
  selector: 'yes-no-page',
  templateUrl: 'yes-no-page.html',
  styleUrls: ['yes-no-page.scss'],
  host: { '[class]': '"ion-page can-go-back"' },
})
export class YesNoPage extends QuestionPage {

  constructor(
    private translateService: TranslateService,
    private injector: Injector,
    public navService: NavService,
  ) {
    super(injector, navService);
  }

  public onYesClick(): void {
    this.answerSelected.emit('yes');
  }

  public onNoClick(): void {
    this.answerSelected.emit('no');
  }
}
